module.exports = __webpack_public_path__ + "img/ws.0f77ff0.png";